<template>
  <ul class="product-usps">
    <slot name="usps">
      <!-- Incentive VVV -->
      <li class="product-usp incentive-product-usp" v-if="hasVVVIncentive">
        <span class="label">Met gratis VVV cadeaubon t.w.v. €10,-
        </span>
      </li>
      <!-- Contract duration -->
      <li class="product-usp"
        v-if="product.contract_duration === 1 && product.tariff_type !== 'dynamic' && product.tariff_type !== 'dynamic_gas_fixed'">
        <icon icon="x-fa-check" size="sm"> </icon>
        <span class="label">
          Variabel contract
        </span>
      </li>
      <li class="product-usp" v-if="product.contract_duration === 1 && product.tariff_type === 'dynamic'">
        <icon icon="x-fa-check" size="sm"> </icon>
        <span class="label">
          Dynamisch contract
        </span>
      </li>
      <li class="product-usp" v-if="product.tariff_type === 'dynamic_gas_fixed'">
        <icon icon="x-fa-check" size="sm" />
        <span class="label">
          Dynamische stroomtarieven, vaste gasprijs
        </span>
      </li>
      <li class="product-usp" v-else-if="product.tariff_type === 'fixed'">
        <icon icon="x-fa-check" size="sm"> </icon>
        <span class="label">
          {{ product.contract_duration_text }} vast contract</span>
      </li>
      <!-- Discount -->
      <li class="product-usp" v-if="product.total_discount > 0">
        <icon icon="x-fa-check" size="sm"> </icon>
        <span class="label">
          {{ toCurrencyShortEur(product.total_discount) }} korting
        </span>
      </li>
      <li class="product-usp"
        v-else-if="product.tariff_type !== 'dynamic' && product.tariff_type !== 'dynamic_gas_fixed'">
        <icon icon="x-fa-check" size="sm"> </icon>
        <span class="label"> {{ product.discount_text }} </span>
      </li>
      <li class="product-usp" v-if="showFixedRateEndDate">
        <icon icon="x-fa-check" size="sm"> </icon>
        <span class="label">
          Tarieven vast t/m {{ parsedFixedRateEndDate }}
        </span>
      </li>
    </slot>
  </ul>
</template>

<script>
import { computed } from 'vue';
import { useOrderStore } from '../../energyComparer/stores/orderStore';
import Icon from '../../../vue-elements/icon/Icon.vue';


export default {
  components: { Icon },
  props: {
    // product: Object,
    product: null,
  },
  setup(props) {
    const orderStore = useOrderStore();
    const hasVVVIncentive = computed(() => orderStore.hasVVVIncentive);

    return {
      hasVVVIncentive
    };
  },
  computed: {
    showFixedRateEndDate() {
      return !!this.product.fixed_rate_end_date;
    },
    parsedFixedRateEndDate() {
      return new Date(this.product.fixed_rate_end_date).toLocaleDateString('nl-NL');
    },
  }
};
</script>

<style lang="scss" scoped>
@use 'assets/scss/_helpers/display';
@use 'assets/scss/_helpers/typography';
@use 'assets/scss/_variables/colors';
@use 'assets/scss/_helpers/breakpoint';

.product-usps {
  display: grid;
  gap: 4px;
  align-items: center;
  margin: 16px 0;
  list-style: none;
  padding: 0;

  @include breakpoint.up(lg) {
    margin: 24px 0;
  }

  .product-usp {
    @include typography.content-short;

    &.incentive-product-usp {
      display: flex;
      padding: 6px 8px;
      background: colors.$all-yellow-80;
      border-radius: 6px;
      margin-bottom: 6px;
      font-weight: 600;
      font-size: 15px;
      gap: 8px;
      align-items: center;
      width: fit-content;
    }
  }

  .icon-element {
    background-color: colors.$text-positive;
    margin-right: 8px;
  }
}
</style>
